import React from 'react';
import Sidebar from '../components/Sidebar'
import Header from '../components/Header';
import Services from '../components/Services';
import WhoIAm from '../components/WhoIAm'
import Contact from '../components/Contact';
import Gallery from '../components/Gallery';

function Home() {
  return (
    <div id = "home">
      <Sidebar />
      <div className="w3-main" style={{ marginLeft: "300px", paddingLeft: "40px", paddingRight: "40px" }}>

        <Header/>
        <WhoIAm/>
        <Services/>
        <Gallery/>
        <Contact/>
      </div>
    </div>
  );
}

export default Home;
